/* Scroll Down Articles
======================================== */
$('.module-article_media-thumb').click(function(){
	var w = window.innerHeight;
	$('html, body').animate({
		scrollTop: w/2 - (w - $(this).outerHeight())
	}, speed*2, ease);
});

/* Article slider
====================================  */
$('.module-article_slider-track').scroll(function(){
	var t = $(this),
			target;
	t.children().each(function(){
		if($(this).offset().left < window.innerWidth/2){
			target = $(this);
		}
	})
	t.next().find('.module-article_slider-current').text(target.data('pos'))
	// t.next().next().find('.module-article_slider-caption').text(target.data('caption'))
});

/* Video player
==================================== */
$('.video-player_video').each(function(){
	// Video
	var $video = $(this),
			$wrapper = $video.next(),
			$play = $wrapper.find('.button-play'),
			$sound = $wrapper.find('.button-sound'),
			$full_screen = $wrapper.find('.button-full-screen'),
			$progress_bar = $wrapper.find('.progress-bar'),
			$progress = $wrapper.find('.time-bar')

	function play(){
		$video.addClass('playing');
		$video[0].play()
		$play
			.addClass('active')
			.text($play.attr('data-label-pause') || 'PAUSE')
	}
	function pause(){
		$video.removeClass('playing');
		$video[0].pause()
		$play
			.removeClass('active')
			.text($play.attr('data-label-play') || 'PLAY')
	}
	function playPause(){
		if($video[0].paused){
			play()
		}else{
			pause()
		}
	}

	//Play/Pause
	$video.click(function(){
		playPause()
	});
	$play.click(function(){
		playPause()
	});

	//Mute video on button click
	$sound.click(function(){
		$(this).toggleClass('active');
		$(this).text($(this).hasClass('active') ? $(this).attr('data-label-off') : $(this).attr('data-label-on'));
		$video[0].muted = !$video[0].muted;
	});

	//Fullscreen
	$full_screen.click(function(){
		$video.toggleClass('full-screen');
		var v = $video[0];
		if(v.paused){
			play()
		}
		if(v.requestFullscreen){
			v.requestFullscreen();
		}else if(v.webkitEnterFullscreen){
			v.webkitEnterFullscreen();
		}else if(v.webkitRequestFullscreen){
			v.webkitRequestFullscreen();
		}else if(v.mozRequestFullScreen){
			v.mozRequestFullScreen();
		}else if(v.msRequestFullscreen){
			v.msRequestFullscreen();
		}
	});

	//Video duration timer
	$video.on('timeupdate', function(){
		var P = 100 * $video[0].currentTime / $video[0].duration;
		$progress.css('width', P + '%');
	}).on('ended', function(){
		$video.removeClass('playing')
		$play.removeClass('active').text('PLAY')
		$progress.css('width', '100%');
	}).on('webkitfullscreenchange webkitendfullscreen mozfullscreenchange fullscreenchange', function(e){
		var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen,
				event = state ? 'FullscreenOn' : 'FullscreenOff';
		if(event == 'FullscreenOff'){
			if(!$video[0].paused){
				pause()
				$video.removeClass('full-screen');
			}
		}
	});

	//Progress bar
	function updatebar(x){
		p = x - $progress.offset().left;
		P = 100 * p / $progress_bar.width();
		if(P > 100){
			P = 100;
		}
		if(P < 0){
			P = 0;
		}
		$progress.css('width', P + '%');
		$video[0].currentTime = $video[0].duration * P / 100;
	}
	var timeDrag = false;
	$progress_bar.on('mousedown', function(e){
		timeDrag = true;
		updatebar(e.pageX);
	});
	$(document).on('mouseup', function(e){
		if(timeDrag){
			timeDrag = false;
			updatebar(e.pageX);
		}
	}).on('mousemove', function(e){
		if(timeDrag){
			updatebar(e.pageX);
		}
	});

});